import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from "src/app/shared/vo/pless-request.model";

/**
 * 画像情報管理削除要求
 */
@Injectable()
export class DeleteImageInfoService extends PlessJsonResponderSub<any> {

  vo = {
    formId: '',
    imageId: [],
  };

  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof DeleteImageInfoService
   */
  private getBody(): PlessRequest {
    const combinations = this.vo.imageId.map(imageId => (
      {
        parameter: {
          ImageId: imageId
        }
      }
    ));

    return new PlessRequest({
      delete: {
        Rec: {
          parameter: {
            FormId: this.vo.formId
          },
          combination: combinations
        }
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param {any} [vo]
   * @param {Function} [successFunc=null]
   * @memberof DeleteImageInfoService
   */
  execute(vo, successFunc: Function = null): void {
    this.successFunc = successFunc;
    this.vo = vo;
    this.send('KYMW17DeleteImageInfo', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof DeleteImageInfoService
   */
  success(data: any): void {
    if (this.successFunc !== null && data !== null) {
      this.successFunc(data);
    }
  }
}
